/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/** @jsx h */

import { h, Component } from 'preact';
import { Link } from 'preact-router/match';
import * as router from 'preact-router';
import FontAwesome from 'react-fontawesome';
import { connect } from 'preact-redux';
import { Link as ScrollLink } from 'react-scroll';
import { bindActionCreators } from 'redux';
import cn from 'classnames';
// eslint-disable-next-line import/no-cycle
import Select from './select';
import Hr from '../../hr';
import { apiRoot } from '../../../api';
import { logOff, changeLocale, sendGlobalMessage } from '../../../actions/user';
import Redirect from '../redirect';
// eslint-disable-next-line import/no-cycle
import { routes, langRoutes } from '../../app';
import { langPack } from '../../../utils/langPack';
import {
  EN, langs, consts,
} from '../../../utils/consts';
// eslint-disable-next-line import/no-cycle
import { processGlobalMessage } from '../../../utils/prismic-middleware';
import SearchPros from './searchPros';

import Alert from '../../ui/alert';

import style from './style.scss';
import Button from '../../ui/button';

import { CREATE_CALL_ERROR } from '../../../actions/chat';

const LANDING_HOST = 'https://www.telmie.com/';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loggedOff: false,
      mobileMenuOpened: false,
      isTop: true,
      globalMessage: null,
      notificationMessage: null,
      workingAsProWarningDismissed: false,
    };
  }

  componentDidMount() {
    const that = this;
    window.addEventListener('scroll', this.handleScroll);
    router.subscribers.push(() => {
      that.setState({
        mobileMenuOpened: false,
      });
    });

    this.props.prismicCtx && this.fetchPage(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (typeof this.props.userAuth !== 'undefined' && typeof nextProps.userAuth !== 'undefined') {
      if (Object.keys(this.props.userAuth).length !== 0 && Object.keys(nextProps.userAuth).length === 0) {
        this.setState({
          loggedOff: true,
          workingAsProWarningDismissed: false,
        });
      } else {
        this.setState({
          loggedOff: false,
        });
      }
    }

    if ((this.props.prismicCtx == null && nextProps.prismicCtx != null)
      || this.props.uid !== nextProps.uid) {
      this.fetchPage(nextProps);
    }

    if (nextProps.transactions.transactionId !== this.props.transactions.transactionId && nextProps.transactions.added) {
      const message = `${langPack[this.props.locale.locale].HEADER.WELL_DONE}! £${nextProps.transactions.added} ${langPack[this.props.locale.locale].HEADER.SUCCESSFULLY_ADDED_BALANCE}!`;
      this.setState({
        notificationMessage: message,
        transactionId: nextProps.transactions.transactionId,
      });
      if (this.hideMessageInterval) {
        clearTimeout(this.hideMessageInterval);
      }

      /*
      * Hide global message
      * */
      this.hideMessageInterval = setTimeout(() => {
        if (this.state.transactionId === this.props.transactions.transactionId || !this.props.transactions.transactionId) {
          this.setState({
            notificationMessage: '',
          });
        }
      }, 5000);
    }

    if (nextProps.message && nextProps.message !== this.state.notificationMessage) {
      this.setState({
        notificationMessage: nextProps.message,
      });
      this.hideMessageInterval = setTimeout(() => {
        if (nextProps.message === this.state.notificationMessage) {
          this.setState({
            notificationMessage: '',
          });
          nextProps.sendGlobalMessage('');
        }
      }, 5000);
    }

    const userIdWas = this.props.userData ? this.props.userData.id : undefined;
    const userIdIs = nextProps.userData ? nextProps.userData.id : undefined;
    const userWasPro = !!(this.props.userData.pro && this.props.userData.pro.proState);
    const userIsPro = !!(nextProps.userData.pro && nextProps.userData.pro.proState);
    const userWasWorkingAsPro = userWasPro ? this.props.userData.pro.proState.proWork : false;
    const userIsWorkingAsPro = userIsPro ? nextProps.userData.pro.proState.proWork : false;
    const isSameUser = !!((userIdWas && userIdIs && userIdWas === userIdIs) || (userIdWas === undefined && userIdWas === undefined));

    if ((isSameUser && (userWasPro && userWasWorkingAsPro && userIsPro && !userIsWorkingAsPro)) || (!isSameUser)) {
      this.setState({
        workingAsProWarningDismissed: false,
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  fetchPage = (props) => {
    const that = this;

    props.prismicCtx.api.getByID(props.uid).then((page) => {
      if (page) {
        that.setState({ globalMessage: processGlobalMessage(page.data) });
      }
    });
  };

  handleScroll = () => {
    const { isTop } = this.state;

    if (window.pageYOffset || document.documentElement.scrollTop) {
      if (isTop) {
        this.setState({ isTop: false });
      }
    } else if (!isTop) {
      this.setState({ isTop: true });
    }
  }

  logOff = () => {
    this.setState({
      loggedOff: true,
    }, () => {
      router.route(routes.LOG_IN);
      if (this.props.onLogout && typeof this.props.onLogout === 'function') {
        this.props.onLogout();
      }
      this.props.logOff();
    });
  };

  toggleMobileMenu = (e) => {
    this.setState((prev) => ({ mobileMenuOpened: !prev.mobileMenuOpened }));
    if (e.target.text === 'Become a Pro') {
      firebase.analytics().logEvent('Tap_menu_Become_Pro_');
    }
  };

  dismissWorkingAsProWarning = () => {
    this.setState({
      workingAsProWarningDismissed: true,
    });
  }

  updateApplication = () => {
    window.location.reload();
  }

  openComModal = () => this.props.openComModal(consts.CHAT);

  render() {
    const { userData: user = {}, locale: localeObj, currentUrl, badges, applicationShouldUpdate } = this.props;
    const { languages } = localeObj;
    const locale = localeObj.locale || EN;
    const isLogin = !!user.id;
    const isAtHome = this.props.currentUrl === routes.HOME
      || Object.keys(langs).some((el) => this.props.currentUrl === langRoutes(langs[el].code, routes.HOME))
      || this.props.currentUrl.toString().indexOf('/#') === 0;

    const isAtBlog = this.props.currentUrl === routes.BLOG
      || !!(this.props.currentUrl.indexOf('/blog') + 1);
    const isServicePage = !!(this.props.currentUrl.toString().indexOf(routes.IMMIGRATION_CONSULTANT) + 1)
      || !!(this.props.currentUrl.toString().indexOf(routes.IMMIGRATION_ADVICE) + 1)
      || !!(this.props.currentUrl.toString().indexOf(routes.LANGUAGE_PRACTICE) + 1)
      || !!(this.props.currentUrl.toString().indexOf(routes.LANGUAGE_LEARNERS) + 1);
    const { globalMessage, notificationMessage } = this.state;

    const newChats = badges.data ? (badges.data.totalMissedCall + badges.data.totalMissedMessage) || '' : '';

    const isWorkingAsPro = user.pro && user.pro.proState && user.pro.proState.proWork;
    const { workingAsProWarningDismissed: isWorkingAsProWarningDismissed } = this.state;
    const displayNotWorkingAsProAlert = user.pro && !isWorkingAsPro && !isWorkingAsProWarningDismissed;

    return (
      <header
        className={`uk-navbar uk-navbar-container ${!this.state.isTop && style.smallHeader} ${globalMessage && 'globalMessage'} ${displayNotWorkingAsProAlert && 'proAlert'}`}
        style={{
          width: '100%', position: 'fixed', zIndex: 200, margin: '0 auto', top: 0, display: 'flex', flexWrap: 'wrap',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
          <div id={style.header}>
            <div
              id={style.mobileShadow}
              className={this.state.mobileMenuOpened ? style.opened : ''}
              onClick={this.toggleMobileMenu}
            />
            <div className={`${style.navbarLeft} uk-navbar-left`}>
              { this.state.loggedOff && <Redirect to={routes.LOG_IN} /> }

              <div className={style.logoWrapper}>
                <a href={LANDING_HOST} id={style.logo}>
                  <img src="/assets/logo.png" alt="Telmie App" />
                </a>
                { isAtBlog ? <b className={style.title}>{langPack[locale].BLOG_TITLE}</b> : null }

                { isServicePage && <Select locale={locale} curUrl={this.props.currentUrl} /> }

                {!(isServicePage || isAtBlog)
                  ? (
                    <span id={style.expandMobileMenu} className={this.state.mobileMenuOpened ? style.opened : ''} onClick={this.toggleMobileMenu}>
                      <span />
                      <span />
                      <span />
                    </span>
                  )
                  : null}
              </div>

              <div className={style.leftNavWrapper}>
                <ul className="uk-navbar-nav" id={style.leftNav}>
                  {
                    isLogin ? ([
                      <li>
                        <Link
                          className={style.headerLink}
                          activeClassName={style.activeLink}
                          href={routes.FIND_PRO}
                          data-style="oldStyle"
                          onClick={() => firebase.analytics().logEvent('Tap_menu_Find_a_Pros')}
                        >
                          {langPack[locale].MISC.FIND_A_PRO}
                        </Link>
                      </li>,
                      (user.pro !== null) && (
                      <li>
                        <Link
                          className={style.headerLink}
                          activeClassName={style.activeLink}
                          href={routes.MY_CLIENTS}
                          data-style="oldStyle"
                        >
                          {langPack[locale].MISC.MY_CLIENTS}
                        </Link>
                      </li>
                      ),
                      <li>
                        <Link
                          className={style.headerLink}
                          activeClassName={style.activeLink}
                          href={routes.MY_PROS}
                          onClick={() => firebase.analytics().logEvent('Tap_menu_My Pros')}
                          data-style="oldStyle"
                        >
                          {langPack[locale].MISC.MY_PROS}
                        </Link>
                      </li>,
                      <li>
                        <Link
                          className={style.headerLink}
                          activeClassName={style.activeLink}
                          href={routes.MY_BOOKINGS}
                          onClick={() => firebase.analytics().logEvent('Tap_menu_My Bookings')}
                          data-style="oldStyle"
                        >
                          {langPack[locale].MISC.MY_APPOINTMENTS}
                        </Link>
                      </li>,
                      <li>
                        <Link
                          className={style.headerLink}
                          activeClassName={style.activeLink}
                          href={routes.TRANSACTIONS}
                          data-style="oldStyle"
                          onClick={() => firebase.analytics().logEvent('Tap_menu_Money_')}
                        >
                          {langPack[locale].HEADER.MONEY}
                        </Link>
                      </li>,
                      (user.pro === null) && (
                      <li>
                        <Link
                          className={style.headerLink}
                          activeClassName={style.activeLink}
                          href={routes.REGISTER_PRO}
                          data-style="oldStyle"
                          onClick={() => firebase.analytics().logEvent('Tap_menu_Become_Pro_')}
                        >
                          {langPack[locale].MISC.BECOME_PRO}
                        </Link>
                      </li>
                      ),
                      <li>
                        <Link
                          className={style.headerLink}
                          activeClassName={style.activeLink}
                          href={routes.SETTINGS}
                          data-style="oldStyle"
                          onClick={() => firebase.analytics().logEvent('Tap_menu_Settings')}
                        >
                          {langPack[locale].HEADER.SETTINGS}
                        </Link>
                      </li>,
                    ])

                      : null
                  }

                </ul>

                <div className={`${style.navbarRight} uk-navbar-right`}>

                  <Select isLocale locale={locale} changeLocale={this.props.changeLocale} languages={languages} />

                  { !isLogin ? (
                    <nav>
                      <ul className="uk-navbar-nav">
                        <li><a onClick={() => firebase.analytics().logEvent('Tap_Register')} id={style.signUp} data-style="oldStyle" href="https://www.telmie.com/download-app">{langPack[locale].MISC.SIGN_UP}</a></li>
                        <li><Link activeClassName={style.activeLink} data-style="oldStyle" href={routes.LOG_IN}>{langPack[locale].HEADER.LOGIN}</Link></li>
                      </ul>
                    </nav>
                  ) : (
                    <div className={style.loggedInContainer}>
                      <div className={style.avatar}>
                        {(user.avatar || user.imgUrl) ? (
                          <img src={user.avatar ? `${apiRoot}image/${user.avatar.id}` : user.imgUrl ? user.imgUrl : ''} alt={`${user.name} ${user.lastName}`} />
                        ) : (
                          <img src="/assets/nouserimage.jpg" alt={`${user.name} ${user.lastName}`} />
                        )}
                        {newChats && <div className={style.newChats}>{newChats}</div>}
                      </div>
                      <div className="mobile-hide">
                        { user.name } { user.lastName }
                      </div>
                      <FontAwesome name="caret-down" />
                      <div className={`${style.dropdown} uk-dropdown`}>
                        <ul className="uk-nav uk-dropdown-nav">
                          <li>
                            <Link href={routes.EDIT_PROFILE}>{langPack[locale].HEADER.EDIT_PROFILE}</Link>
                          </li>
                          <li>
                            <Link href={routes.REGISTER_PRO}>
                              { user.pro ? langPack[locale].HEADER.EDIT_PRO_DETAILS : langPack[locale].MISC.REGISTER_AS_PRO}
                            </Link>
                          </li>
                          <li>
                            <Link href={routes.SETTINGS} onClick={() => firebase.analytics().logEvent('Tap_menu_Settings')}>
                              {langPack[locale].HEADER.SETTINGS}
                            </Link>
                          </li>
                          { newChats && <li className={style.chats} onClick={this.openComModal}>{langPack[locale].HEADER.NEW_CHATS}: {newChats}</li>}
                          <li className="uk-nav-divider" />
                          <li><a onClick={this.logOff}>{langPack[locale].MISC.LOG_OUT}</a></li>
                        </ul>
                      </div>

                    </div>
                  )}

                </div>
              </div>

            </div>
            <div id={style.mobileNav} className={this.state.mobileMenuOpened ? style.opened : ''}>
              <div className={style.mobileNavHeader}>
                <Link href={langRoutes(langs[locale].code, routes.HOME)} id={style.logo}>
                  <img src="/assets/logo.png" alt="Telmie App" />
                </Link>
                <span id={style.expandMobileMenu} className={this.state.mobileMenuOpened ? style.opened : ''} onClick={this.toggleMobileMenu}>
                  <span /><span /><span />
                </span>
              </div>

              {isAtHome
                ? <ScrollLink spy smooth offset={globalMessage ? -90 : -30} duration={500} to="howWorksElement" onClick={this.toggleMobileMenu}>{langPack[locale].HEADER.HOW_IT_WORKS}</ScrollLink>
                : <Link className={style.headerLink} data-style="oldStyle" href={langRoutes(langs[locale].code, routes.HOW_WORKS_LINK)} onClick={this.toggleMobileMenu}>{langPack[locale].HEADER.HOW_IT_WORKS}</Link>}
              {(isAtHome && langPack[locale].MISC.BECOME_PRO)
                ? <ScrollLink spy smooth offset={globalMessage ? -130 : -70} duration={500} to="becomeProElement" onClick={this.toggleMobileMenu}>{langPack[locale].MISC.BECOME_PRO}</ScrollLink>
                : <Link className={style.headerLink} data-style="oldStyle" href={langRoutes(langs[locale].code, routes.BECOME_PRO_LINK)} onClick={this.toggleMobileMenu}>{langPack[locale].MISC.BECOME_PRO}</Link>}
              {isAtHome
                ? <ScrollLink spy smooth offset={globalMessage ? -100 : -25} duration={500} to="blogElement" onClick={this.toggleMobileMenu}>{langPack[locale].MISC.BLOG}</ScrollLink>
                : <Link className={style.headerLink} data-style="oldStyle" href={langRoutes(langs[locale].code, routes.BLOG_LINK)} onClick={this.toggleMobileMenu}>{langPack[locale].MISC.BLOG}</Link>}
              {isAtHome
                ? <ScrollLink spy smooth offset={globalMessage ? -100 : -30} duration={500} to="FAQElement" onClick={this.toggleMobileMenu}>{langPack[locale].HEADER.FAQ}</ScrollLink>
                : <Link className={style.headerLink} data-style="oldStyle" href={langRoutes(langs[locale].code, routes.FAQ)} onClick={this.toggleMobileMenu}>{langPack[locale].HEADER.FAQ}</Link>}
              {isAtHome
                ? <ScrollLink spy smooth offset={globalMessage ? -60 : 0} duration={500} to="contactUsElement" onClick={this.toggleMobileMenu}>{langPack[locale].HEADER.CONTACT}</ScrollLink>
                : <Link className={style.headerLink} data-style="oldStyle" href={langRoutes(langs[locale].code, routes.CONTACT_US)} onClick={this.toggleMobileMenu}>{langPack[locale].HEADER.CONTACT}</Link>}

              { !isLogin ? (
                <div>
                  <Hr color="#5C636E" height={1} />
                  <a href="https://www.telmie.com/download-app" id={style.signUp} data-style="oldStyle">{langPack[locale].MISC.SIGN_UP}</a>
                  <Link href={routes.LOG_IN} data-style="oldStyle">{langPack[locale].HEADER.LOGIN}</Link>
                </div>
              ) : (
                <div>
                  <Hr color="#5C636E" height={1} />
                  <Link activeClassName={style.activeLink} href={routes.FIND_PRO} onClick={() => firebase.analytics().logEvent('Tap_menu_Find_a_Pros')} data-style="oldStyle">{langPack[locale].MISC.FIND_A_PRO}</Link>
                  <Link activeClassName={style.activeLink} href={routes.MY_PROS} onClick={() => firebase.analytics().logEvent('Tap_menu_My Pros')} data-style="oldStyle">{langPack[locale].MISC.MY_PROS}</Link>
                  <Link activeClassName={style.activeLink} href={routes.MY_BOOKINGS} onClick={() => firebase.analytics().logEvent('Tap_menu_My Bookings')} data-style="oldStyle">{langPack[locale].MISC.MY_APPOINTMENTS}</Link>
                  {(user.pro !== null) && <Link activeClassName={style.activeLink} href={routes.MY_CLIENTS} data-style="oldStyle">{langPack[locale].MISC.MY_CLIENTS}</Link>}
                  <Link activeClassName={style.activeLink} href={routes.TRANSACTIONS} onClick={() => firebase.analytics().logEvent('Tap_menu_Money_')} data-style="oldStyle">{langPack[locale].HEADER.MONEY}</Link>
                  {(user.pro === null) && <Link activeClassName={style.activeLink} href={routes.REGISTER_PRO} data-style="oldStyle">{langPack[locale].MISC.BECOME_PRO}</Link>}
                  <Link activeClassName={style.activeLink} href={routes.SETTINGS} onClick={() => firebase.analytics().logEvent('Tap_menu_Settings')} data-style="oldStyle">{langPack[locale].HEADER.SETTINGS}</Link>
                  <a onClick={() => this.logOff()} data-style="oldStyle">{langPack[locale].MISC.LOG_OUT}</a>
                </div>
              )}

            </div>
          </div>
          {
            currentUrl === routes.SEARCH && isLogin && (
              <SearchPros />
            )
          }
        </div>

        { globalMessage && (
        <div id={style.subHeader}>
          <div className={style.content}> { globalMessage } </div>
        </div>
        )}
        { notificationMessage && (
        // Hotfix for notificationDanger TWMA-620. Approved with QA
        <div
          id={style.subHeader}
          className={cn({
            [style.notificationDanger]: notificationMessage === CREATE_CALL_ERROR,
          })}
        >
          <div className={style.content}> { notificationMessage } </div>
        </div>
        )}
        { displayNotWorkingAsProAlert && (
          <Alert color="warning" isClosable content={langPack[locale].PRO.WORKING_AS_PRO_OFF} onHide={this.dismissWorkingAsProWarning} />
        )}
        { applicationShouldUpdate && (
          <Alert color="warning" content={langPack[locale].NOTIFICATIONS.UPDATE_APPLICATION_VERSION}>
            <Button onClick={this.updateApplication}>{langPack[locale].MISC.UPDATE_NOW}</Button>
          </Alert>
        )}
      </header>
    );
  }
}

const mapStateToProps = (state) => ({
  userData: state.loggedInUser,
  locale: state.locale,
  newChats: state.communicateModal.unread,
  currentUrl: state.url.url,
  transactions: state.loggedInUserTransactions,
  message: state.globalMessage.message,
  badges: state.badges,
  applicationShouldUpdate: state.application.applicationShouldUpdate,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  logOff,
  changeLocale,
  sendGlobalMessage,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Header);



// WEBPACK FOOTER //
// ./components/global/header/index.js